import {useMergeContext} from '../../../store/mergeContext'
import {useTheme} from '@emotion/react'
import {Box, Stack, Paper, Typography, Divider, styled} from '@mui/material'
import {DataGrid, gridClasses} from '@mui/x-data-grid'
import {useState, useEffect, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {Trans} from '@lingui/macro'
import {
    COLLECTED_BY_ID,
    CRASH_ID_KEY,
    getColumnsModel,
    getOrganization
} from '../utils'
import {getConfigOptions, mapObjectToLabels} from '../../Statistics/utils'
import UserControls from '../../../components/desktop/UserControls'
import {StripedDataGrid} from "../../../components/tables/StripedDataGrid";
import DesktopToolbar from "../../../components/desktop/DesktopToolbar";


export const CrashTable = () => {
    const {crashes, handleSelectedCrash, mergedCrashes} = useMergeContext()

    const [columns, setColumns] = useState([])
    const [columnGroupingModel, setColumnGroupingModel] = useState([])
    const [rows, setRows] = useState([])
    const [validatedRow, setValidatedRows] = useState([])
    const [user, setUser] = useState({})
    const location = useLocation()
    const state = location.state
    const theme = useTheme()
    const drawerWidth = theme.mixins.drawerWidth
    const init = useMemo(
        () => location.state?.init || {},
        [location.state?.init]
    )
    const organizations = useMemo(
        () => location.state?.init?.organizations || {},
        [location]
    )
    console.log('organizations::', organizations)


    useEffect(() => {
        const {configuration} = init

        const configOptions = getConfigOptions(configuration)

        const mappedCrashes = mergedCrashes.map(crash =>
            mapObjectToLabels(crash, configOptions)
        )

        const preparedRows = mappedCrashes.map(
            crash => (
                console.log('crash::', crash),
                    {
                        ...crash.crash
                        , units: Object.entries(crash?.units)?.length
                        , people:
                            Object.values(crash?.units)?.flatMap(v =>
                                Object.values(v?.people)?.flatMap(p => p)
                            )?.length + Object.values(crash?.people || {})?.length
                        , [COLLECTED_BY_ID]: getOrganization(
                            crash?.crash?.[COLLECTED_BY_ID],
                            organizations
                        )
                    }
            )
        )

        console.log('prepared rows :: ', preparedRows)

        setValidatedRows(
            preparedRows?.map((row, index) => ({...row, id: index}))
        )
    }, [init, mergedCrashes, organizations])

    useEffect(() => {
        const {configuration, user} = init
        setUser(user)

        const configOptions = getConfigOptions(configuration)

        const mappedCrashes = crashes.map(crash =>
            mapObjectToLabels(crash, configOptions)
        )

        const preparedRows = mappedCrashes.map(crash => ({
            ...crash.crash
            , units: Object.entries(crash?.units)?.length
            , people:
                Array.isArray(Object.values(crash?.units)) &&
                Object.values(crash?.units)?.flatMap(uni =>
                    Object.values(uni?.people)?.flatMap(p => p)
                )?.length
            , [COLLECTED_BY_ID]: getOrganization(
                crash?.crash?.[COLLECTED_BY_ID],
                organizations
            )
        }))

        setRows(preparedRows?.map((row, index) => ({...row, id: index})))

        const {columns} = getColumnsModel(configuration)

        setColumnGroupingModel()

        setColumns(columns)
    }, [init, crashes, organizations])

    return (
        <Stack direction="column">
            <Box sx={{p:1,borderBottom: `1px solid ${theme.palette.newColors.gray}`}}>
                <Typography sx={{color: theme.palette.mode === 'light' ? theme.palette.newColors.gray : theme.palette.newColors.lightGray,fontWeight:'bold',fontSize:24}}>
                    <Trans>Data Merging and validation</Trans>
                    </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%',marginBottom:1,padding:2 }}>
                <Typography sx={{color:theme.palette.mode === 'light' ? theme.palette.newColors.gray : 'white',fontWeight:'bold',fontSize: 18,ml: -2 }} variant="h3">
                    <Trans>SELECT A CRASH TO VALIDATE</Trans>
                </Typography>

            </Box>
            <Paper sx={{ mb: 2 }}>
                <StripedDataGrid
                    rowSelection
                    onRowClick={e => handleSelectedCrash(e?.row?.[CRASH_ID_KEY])}
                    showColumnVerticalBorder
                    showCellVerticalBorder
                    rows={rows}
                    columns={columns}
                    editMode="row"
                    columnGroupingModel={columnGroupingModel}
                    pageSizeOptions={[5]}
                    sx={{
                        border: 0
                        , '& .MuiDataGrid-menuIcon > *': {
                            color: theme.palette.primary.contrastText
                        }
                    }}
                />
            </Paper>

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%',marginBottom:1,padding:2 }}>
                <Typography sx={{color: theme.palette.mode === 'light' ? theme.palette.newColors.gray : 'white',fontWeight:'bold',fontSize: 18,ml: -2 }} variant="h3">
                    <Trans>VALIDATED CRASHES</Trans>
                </Typography>

            </Box>
            <Divider sx={{ mb: 2 }} />
            <Paper sx={{ pt: -1, mb: 2 }}>
                <StripedDataGrid
                    rowSelection
                    onRowClick={e => handleSelectedCrash(e?.row?.[CRASH_ID_KEY], true, crashes)}
                    showColumnVerticalBorder
                    showCellVerticalBorder
                    rows={validatedRow}
                    columns={columns}
                    editMode="row"
                    columnGroupingModel={columnGroupingModel}
                    pageSizeOptions={[5]}
                    sx={{
                        border: 0
                        , '& .MuiDataGrid-menuIcon > *': {
                            color: theme.palette.primary.contrastText
                        }
                    }}
                />
            </Paper>
        </Stack>
    )
}
